import { z } from 'zod';
import { DocumentTypeSchema } from '../catalogs/domain-catalogs.js';
import { BusinessDateSchema, TimestampSchema } from '../common/clock.js';
import { ApplicationIdSchema, CreditLineIdSchema, CustomerIdSchema } from '../common/ids.js';
import { PhoneSchema, TokenPairSchema } from './auth.js';
export const CustomerStatusSchema = z
    .enum(['PROSPECT', 'ACTIVE', 'BLOCKED'])
    .meta({ id: 'CustomerStatus' });
/** Entidad interna (no se expone tal cual: la API enmascara documento, celular y cuentas). */
export const CustomerRecordSchema = z.object({
    id: CustomerIdSchema,
    documentType: DocumentTypeSchema,
    documentNumber: z.string(),
    fullName: z.string(),
    phone: PhoneSchema,
    email: z.email().nullable(),
    birthDate: BusinessDateSchema.nullable(),
    businessName: z.string().nullable(),
    status: CustomerStatusSchema,
    externalCustomerId: z.string().nullable(),
    isDemoSeed: z.boolean(),
});
export const LinkedAccountSchema = z.object({
    id: z.string(),
    participantCode: z.string(),
    participantName: z.string(),
    accountType: z.string(),
    maskedNumber: z.string(),
    creditLineId: CreditLineIdSchema.nullable(),
    isDefault: z.boolean(),
});
/** `GET /v1/customers/me`. */
export const CustomerProfileSchema = z
    .object({
    id: CustomerIdSchema,
    fullName: z.string(),
    documentType: DocumentTypeSchema,
    maskedDocument: z.string(),
    phone: z.string().meta({ description: 'Celular del propio cliente (visible para él).' }),
    email: z.string().nullable(),
    businessName: z.string().nullable(),
    status: CustomerStatusSchema,
    linkedAccounts: z.array(LinkedAccountSchema),
    hasActiveLine: z.boolean(),
    activeApplicationId: ApplicationIdSchema.nullable(),
    preferences: z.object({
        voiceEnabled: z.boolean(),
        notifications: z.object({ push: z.boolean(), sms: z.boolean(), whatsapp: z.boolean() }),
    }),
})
    .meta({ id: 'CustomerProfile' });
export const UpdateCustomerPreferencesRequestSchema = CustomerProfileSchema.shape.preferences.partial();
/** Consentimientos (habeas data, consulta a centrales, términos, IA, comunicaciones). */
export const ConsentTypeSchema = z
    .enum(['HABEAS_DATA', 'BUREAU_QUERY', 'TERMS', 'AI_PROCESSING', 'ELECTRONIC_COMMS'])
    .meta({ id: 'ConsentType' });
export const ConsentSchema = z.object({
    type: ConsentTypeSchema,
    version: z.string(),
    grantedAt: TimestampSchema,
    revokedAt: TimestampSchema.nullable(),
    evidence: z.object({
        channel: z.string(),
        ip: z.string().optional(),
        otpChallengeId: z.string().optional(),
    }),
});
export const CustomerNotificationSchema = z.object({
    id: z.string(),
    title: z.string(),
    body: z.string(),
    deepLink: z.string().nullable(),
    readAt: TimestampSchema.nullable(),
    createdAt: TimestampSchema,
});
/** `POST /v1/auth/otp/verify` → tokens + perfil del cliente. */
export const OtpVerifyResponseSchema = TokenPairSchema.extend({
    customer: CustomerProfileSchema,
}).meta({
    id: 'OtpVerifyResponse',
});
//# sourceMappingURL=customer.js.map